import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  marginBottom: 4,

  '&:last-child': {
    marginBottom: 0,
  },
};

const styles = {
  container,
};

export default styles;
